"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CircleCheck } from "lucide-react";
const services = [{
  title: "Flat Tire Repair",
  category: "Emergency",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/flat_tire_repair_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/flat_tire_repair_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/flat_tire_repair_service.png-wvc-sizes",
  features: ["Puncture Patching", "Valve Stem Replacement", "Safety Inspection"]
}, {
  title: "Tire Replacement",
  category: "Installation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tire_replacement_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tire_replacement_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tire_replacement_service.png-wvc-sizes",
  features: ["New Tire Options", "All Major Brands", "Expert Mounting"]
}, {
  title: "Wheel Balancing",
  category: "Performance",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/wheel_balancing_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/wheel_balancing_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/wheel_balancing_service.png-wvc-sizes",
  features: ["High-Speed Balancing", "Vibration Removal", "Extended Tire Life"]
}, {
  title: "TPMS Service",
  category: "Electronics",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tpms_sensor_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tpms_sensor_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tpms_sensor_service.png-wvc-sizes",
  features: ["Sensor Programming", "Battery Testing", "Dashboard Reset"]
}, {
  title: "Tire Rotation",
  category: "Maintenance",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tire_rotation_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tire_rotation_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tire_rotation_service.png-wvc-sizes",
  features: ["Pattern Optimization", "Even Wear Check", "Pressure Adjustment"]
}, {
  title: "Free Tire Inspection",
  category: "Free",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/used_tires_inventory.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/used_tires_inventory.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/used_tires_inventory.png-wvc-sizes",
  alt: "Free tire inspection",
  features: ["Tread depth check", "Pressure and visible-damage check", "Repair or replacement guidance"]
}, {
  title: "Fleet Services",
  category: "Commercial",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/fleet_tire_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/fleet_tire_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/fleet_tire_service.png-wvc-sizes",
  features: ["Priority Scheduling", "Bulk Discounts", "On-Site Support"]
}];
export default function TurnkeySolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="231114" id="full-service-menu" className="bg-background py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-8">
        {}
        <div ref={headerRef} className={`mb-16 flex flex-col items-center text-center transition-all duration-700 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-4xl font-black uppercase italic leading-tight text-foreground tracking-tighter lg:text-6xl">
            Our Services
          </h2>
          <div className="mt-4 h-1 w-24 bg-primary" />
          <p className="mt-6 max-w-2xl font-default text-lg leading-relaxed text-muted-foreground">
            Nova Tire Center delivers high-octane automotive care. From emergency flat repairs to precision TPMS programming, our Los Angeles experts get you back on the asphalt with speed and reliability.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => <Card key={index} data-index={index === 0 ? 0 : undefined} className="group flex flex-col overflow-hidden border-none border-t-4 border-primary bg-card/50 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl rounded-sm">
              <div className="relative aspect-video w-full overflow-hidden">
                <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.alt || service.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute top-4 left-4 bg-primary px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-primary-foreground rounded-sm">
                  {service.category}
                </div>
              </div>
              
              <CardHeader className="pb-2">
                <CardTitle className="font-default text-2xl font-black uppercase italic tracking-tight text-foreground">
                  {service.title}
                </CardTitle>
              </CardHeader>

              <CardContent className="flex flex-1 flex-col justify-between gap-6">
                <ul className="space-y-3">
                  {service.features.map((feature, fIndex) => <li key={fIndex} className="flex items-center gap-3 text-sm text-muted-foreground">
                      <CircleCheck className="h-4 w-4 text-primary" />
                      {feature}
                    </li>)}
                </ul>

                <Link to="tel:+14243138474" className="w-full">
                  <Button className="w-full rounded-sm font-default font-bold uppercase tracking-wider shadow-lg transition-all hover:shadow-primary/20">
                    Call Now
                  </Button>
                </Link>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}